module.exports = __webpack_public_path__ + "img/title.cdcbc247.png";